import Repository from "./Repository";
const resource = "/api/v1/college";
export default {
  getCollegeList(val) {
    let subUrl = `${resource}/${val}`;
    return Repository.sendReq({ method: "get", subUrl });
  },
  getCollegeProfile(id) {
    let subUrl = `${resource}/getone/${id}`;
    return Repository.sendReq({ method: "get", subUrl });
  },
  getFilteredData(values) {
    let subUrl = `${resource}/${values}&limit=10`;
    return Repository.sendReq({ method: "get", subUrl });
  },

  // Verify College
  verifyCollege(data) {
    let subUrl = "/api/v1/collegeVerify";
    return Repository.sendReq({ method: "post", subUrl, data });
  }
};
